import {Component, EventEmitter, inject, Input, OnChanges, Output, signal, SimpleChanges} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";
import {MediaHelperService} from "../../../../core/media-helper.service";
import {fetchReportImageUrls, thumbnailImageIds} from "../report-images";

@Component({
    selector: 'grid-report',
    templateUrl: './grid-report.component.html',
    styleUrls: ['./grid-report.component.scss'],
    standalone: false
})
export class GridReportComponent implements OnChanges {
  private readonly mediaHelper: MediaHelperService = inject(MediaHelperService);

  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;
  @Input() numColumnsInReport = 2;

  /** Emits when every image has loaded or failed, so the PDF can be printed. */
  @Output() imagesReady = new EventEmitter<void>();

  imageUrls = signal(new Map<string, string>());

  private pendingImages = 0;
  private latestUrlRequest = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.extractedArtifacts) {
      this.loadImageUrls().then();
    }
  }

  isPromptSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'vis_ledetekster')?.value;
  }

  isOnlyPhotosSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'kun_bilder')? this.viewOptionsCheckboxValues.find((option) => option.key === 'kun_bilder').value : false;
  }

  imageUrlFor(artifact: any): string | null {
    return this.imageUrls().get(artifact.thumbnailImage.image_id) ?? null;
  }

  onImageSettled() {
    this.pendingImages--;
    this.emitIfAllImagesSettled();
  }

  private async loadImageUrls() {
    const request = ++this.latestUrlRequest;
    const artifacts: any[] = this.extractedArtifacts ?? [];
    const urls = await fetchReportImageUrls(this.mediaHelper, thumbnailImageIds(artifacts));
    if (request !== this.latestUrlRequest) {
      return;
    }
    this.imageUrls.set(urls);
    this.pendingImages = artifacts
      .filter(artifact => urls.has(artifact.thumbnailImage?.image_id))
      .length;
    this.emitIfAllImagesSettled();
  }

  private emitIfAllImagesSettled() {
    if (this.pendingImages === 0) {
      this.imagesReady.emit();
    }
  }

}
